var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlayseek(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1609_12365)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.9999 10.5306L13.6932 5.0438C13.8945 4.7469 13.9999 4.40992 13.9988 4.06707C13.9977 3.72423 13.8901 3.38775 13.6869 3.0918C13.4838 2.79585 13.1923 2.55097 12.8422 2.38205C12.492 2.21312 12.0956 2.12616 11.6932 2.13L4.2799 2.13C3.67521 2.13 3.09528 2.33466 2.6677 2.69896C2.24011 3.06325 1.9999 3.55734 1.9999 4.07253C2.00058 4.41357 2.10632 4.74849 2.30657 5.04379L5.9999 10.5306C6.20017 10.8254 6.48792 11.0702 6.83428 11.2403C7.18063 11.4105 7.57342 11.5001 7.97323 11.5001C8.37305 11.5001 8.76584 11.4105 9.11219 11.2403C9.45855 11.0702 9.74629 10.8254 9.94657 10.5306L9.9999 10.5306Z",
    fill: "#00C48C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1609_12365"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13.6318,
    height: 16,
    fill: "white",
    transform: "translate(16) rotate(90)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayseek);
export default __webpack_public_path__ + "static/media/playseek.07767246c66a004b49b341043ddb4635.svg";
export { ForwardRef as ReactComponent };